import { InjectionKey, Ref } from 'vue'
import { Project } from './projects/Project'
import { User } from './core/User'

const ProjectKey: InjectionKey<Ref<Project>> = Symbol('Project')
const ProjectAccountableOptionsKey: InjectionKey<Array<User>> = Symbol('ProjectAccountableOptions')

export { ProjectKey, ProjectAccountableOptionsKey }
